document.addEventListener("DOMContentLoaded", () => {
  const lang = window.lang || document.documentElement.lang || "de";

  window.amountToHuman = function (amount, avoidCurrency) {
    if (!avoidCurrency) {
      return new Intl.NumberFormat(lang == "de" ? "de-DE" : "en-GB", {
        style: "currency",
        currency: "EUR",
      }).format(amount);
    } else {
      return new Intl.NumberFormat(lang == "de" ? "de-DE" : "en-GB").format(
        amount
      );
    }
  };
});
